/**
 * 📦 COMPOSANT : sellerie-app/frontend/src\index.tsx
 * Ce composant est utilisé dans d'autres pages de l'application
 */

/**
 * Description du fichier:
 * Point d'entrée principal de l'application React qui initialise le rendu dans le DOM.
 * 
 * Relations avec d'autres fichiers:
 * - Importe et monte le composant App qui contient toute la structure de l'application
 * - Configure le BrowserRouter pour gérer la navigation dans l'application
 * - Importe les styles globaux depuis index.css
 * 
 * Actions déclenchées:
 * - Initialise l'application React dans l'élément racine du DOM
 * - Active le mode strict de React pour détecter les problèmes potentiels
 * - Configure le système de routage pour l'ensemble de l'application
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
